export default {
    // 中文
    zh: {
        首页: '首页',
        产品介绍: '产品介绍',
        技术支持: '技术支持',
        商务合作: '商务合作',
        关于我们: '关于我们',
        产品下载: '产品下载',
        相关工具下载: '相关工具下载',
        全语言全品类全场景: '全语言.全品类.全场景',
        为用户提供高效专业的项目和服务: '为用户提供高效专业的“项目+服务”',
        我们致力于为用户提供一站式的实时语言翻译解决方案打造集供应链红人带货: '我们致力于为用户提供一站式的实时语言翻译解决方案，打造集供应链，红人带货',
        互动数据打造直播能手跨境利器: '助力品牌出海 -“互动+数据”打造“直播能手、跨境利器',
        地址: '浙江省杭州市临平区旺盛路6号5幢6楼(整层)',
        专业团队为您出海赋能: '专业团队为您出海赋能',
        小时响应724小时保驾护航: '1小时响应 7*24小时保驾护航',
        加盟合作共享品牌价值与发展机遇: '加盟合作 共享品牌价值与发展机遇',
        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: '您可以通过以下方式快速联系我们，我们携手共进，开拓市场无限可能',
        关于我们的内容: '创始团队一直深耕在互联网信息技术领域，和阿里、腾讯、360等国内知名企业建立了紧密合作伙伴关系。我们秉承“创新、求实、诚信、拼搏”的职业精神，具有丰富的行业经验和专业技术。我们尊重每次合作的机会与挑战，追求品质和自我超越，依托业内上下游资源优势，我们相信我们可以为用户提供出色的解决方案和贴心服务，并将带来巨大的商业价值和社会价值。',
        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: '国际顶尖技术团队国家千人计划技术引领；国内头部跨境运营团队，经验丰富，资源充沛，杭州外贸跨境协会加持。',
        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: '只需为我们的服务付费，我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益。',
        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: '我们在全球范围内建立了高效的供应链系统，确保产品或服务的可靠供应，并满足不同地区的需求。',
        技术支持内容: '国际领先语言识别技术，先进的合流技术，自主创新，阿里巴巴技术支撑，欧洲顶级模型训练技术加持，拥有成熟的软件开发团队。'
    },
    // 英文
    en: {
        首页: 'homePage',
        产品介绍: 'HomepageProduct Introduction',
        技术支持: 'technical Support',
        商务合作: 'Cooperation',
        关于我们: 'About Us',
        产品下载: 'Product download',
        相关工具下载: 'Related tools Download',
        海外电商语言解决方案服务平台: "About China Broadcasting’s Optimal Official WeChat Signal Overseas E - commerce Language Solution Service Platform ",
        全语言全品类全场景: 'All languages, categories, and scenarios',
        联系客服: 'customer service',
        为用户提供高效专业的项目和服务: 'Contact customer service to provide efficient and professional projects and services for users',
        助力产品出海升级转型: 'Assist in upgrading and transforming products overseas',
        开启海外电商新模式: 'Open a new model of overseas e-commerce',
        首页内容: "We are committed to providing users with a one-stop real-time language translation solution to create a supply chain influencer for sales,A service platform that integrates AI translation to help users break down language barriers and achieve real - time voice communication, online interaction Features such as sharing good items.We have multiple translation application scenarios, such as real - time translation, assisted broadcasting translation, and mobile game translationEtc., supporting 180 mainstream languages in different countries and regions.Currently, overseas mainstream platforms such as TikTok, Instagram YouTube, WhatsApp, Line, and Facebook are all compatible.Through our platform, whether it 's direct We can provide high - quality language solutions for product promotion, online education, and live streaming to help users expand their horizonsExhibition, global market, and enhancing competitiveness.Choose us and unlock infinite possibilities ",
        一站式解决方案: 'One-stop solution',
        助力品牌出海: 'help brands go global',
        互动数据打造直播能手跨境利器: '"interactive + data" to create "live streaming experts, cross-border tools"',
        开发经验: 'Development experience',
        覆盖行业: 'Industry coverage',
        客户选择: 'Customer selection',
        行业解决方案: 'Industry solutions',
        请输入您的电话号码: 'Please enter your phone number',
        预约回电: 'Make an appointment for a call back',
        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: 'We provide you with professional pre-sales and after-sales services to help you easily start your cross-border journey',
        杭州国播优选科技有限公司: 'Hangzhou Guobo Youxuan Technology Co., Ltd',
        地址: '6th Floor, Building 5, No. 6 Wangsheng Road, Linping District, Hangzhou City, Zhejiang Province (Whole Floor)',
        国播优选官方微信号: 'Official WeChat account of Guobo Optimal Selection ',
        为品牌海外业绩增长提供全方位资源和服务: 'Provide comprehensive resources and services for the growth of brand overseas performance',
        用户案例: 'User Stories',
        解决方案: 'Solution',
        娱乐平台: 'Entertainment platform',
        家用电器: 'home appliances',
        游戏直播: 'game live streaming',
        教育培训: 'education and training',
        服饰用品: 'clothing and accessories',
        知识付费: 'knowledge payment',
        水晶珠宝: 'crystal jewelry',
        宏冠赛鸽: 'Hongguan racing pigeon ',
        致力为您提供专业的服务与支持: 'Dedicated to providing you with professional services and support',
        系统搭建: 'System setup',
        AI模型: 'AI model',
        视频编程: 'Video programming',
        语音翻译: 'voice translation',
        全方位提供支持服务: 'providing support services in all aspects',
        产品使用指导技术问题解答: 'product usage guidance and technical problem solving',
        客户需求为先: 'customer needs first',
        从满足客户需求到创造客户价值: 'from meeting customer needs to creating customer value',
        落地有保障: 'ensuring implementation',
        专业团队为您出海赋能: 'professional team empowering you to go global',
        极速服务应答: 'Rapid service response',
        小时响应724小时保驾护航: '1-hour response, 7 * 24-hour protection and protection',
        加盟合作共享品牌价值与发展机遇: 'Franchise cooperation, sharing brand value and development opportunities',
        代理合作: 'Agent cooperation',
        平台合作: 'Platform cooperation',
        技术合作: 'Technology cooperation',
        供应链合作: 'Supply chain cooperation',
        合作流程: 'Cooperation process',
        客户需求沟通: 'Customer demand communication',
        方案规划: 'Solution planning',
        确认需求: 'Confirmation of demand',
        专业指导: 'Professional guidance',
        跑通流程: 'Running through the process',
        项目收尾: 'Project closure',
        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: 'Franchise cooperation, sharing brand value and development opportunitiesYou can quickly contact us through the following methods, and we will work together to explore unlimited possibilities in the market ',
        热线联系: 'Hotline contact',
        请联系我们寻求帮助: 'Please contact us for assistance',
        我们将尽快为您提供帮助: 'We will provide you with assistance as soon as possible',
        关于我们的内容: 'We will provide you with assistance as soon as possible. The founding team has been deeply involved in the field of internet information technology and has established close partnerships with well-known domestic enterprises such as Alibaba, Tencent, and 360. We adhere to the professional spirit of "innovation, pragmatism, integrity, and hard work", and have rich industry experience and professional skills. We respect every opportunity and challenge of cooperation, pursue quality and self transcendence, and rely on the advantages of upstream and downstream resources in the industry. We believe that we can provide excellent solutions and thoughtful services to users, and will bring huge commercial and social value',
        公司简介: 'Company Profile',
        我们的优势: 'Our strengths',
        技术优势: 'Technical advantages',
        技术支持内容: 'International leading language recognition technology, advanced convergence technology, independent innovation,Alibaba’s technical support, supported by top European model training technology, possessesMature software development team ',
        顶尖团队: 'top team',
        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: 'Top international technical team, leading the National Thousand Talents Program in technology; A leading domestic cross-border operation team with rich experience and abundant resources, supported by the Hangzhou Cross border Trade Association.',
        低成本: 'low cost',
        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: 'Just pay for our services, our competitive pricing matching strategy means you can get huge profits with our solutions',
        全球覆盖: 'Global coverage',
        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: 'We have established an efficient supply chain system worldwide to ensure reliable supply of products or services and meet the needs of different regions'
    },
    // 日文
    Japanese: {
        首页: 'トップページ',
        产品介绍: '製品の紹介',
        技术支持: 'テクニカルサポート',
        商务合作: 'ビジネス提携',
        关于我们: '私たちについて',
        产品下载: '製品 のダウンロードです',
        相关工具下载: '関連 ツールのダウンロードです',
        海外电商语言解决方案服务平台: "海外電子商取引言語ソリューションサービスプラットフォーム ",
        全语言全品类全场景: '全言語全品種全場面',
        联系客服: 'カスタマーサービスへの連絡',
        为用户提供高效专业的项目和服务: 'カスタマーサービスに連絡して、ユーザーに効率的で専門的なプロジェクトとサービスを提供する',
        助力产品出海升级转型: '製品の海外進出とグレードアップのモデルチェンジを支援する',
        开启海外电商新模式: '海外電子商取引の新モデルをオープ',
        首页内容: "国際的な先進的な言語認識技術、先進的な合流技術、自主革新、アリババ技術サポート、ヨーロッパのトップモデル訓練技術を強化し、成熟したソフトウェア開発チームを持っている。創設チームはインターネット情報技術の分野を深く耕し、アリ、テンセント、360などの国内有名企業と緊密なパートナーシップを築いてきた。私たちは「革新、真実を求め、誠実で、奮闘する」という職業精神を受け継ぎ、豊富な業界経験と専門技術を持っています。私たちは毎回の協力の機会と挑戦を尊重し、品質と自己超越を追求し、業界の上下流資源の優位性に頼って、私たちはユーザーに優れたソリューションと親切なサービスを提供することができ、そして巨大なビジネス価値と社会価値をもたらすと信じています。",
        一站式解决方案: 'ワンストップソリューション',
        助力品牌出海: 'ブランドの海外進出を支援',
        互动数据打造直播能手跨境利器: 'インタラクティブデータによる生中継のための国境を越えた利器の構築',
        开发经验: '開発経験',
        覆盖行业: '業界をカバー',
        客户选择: 'お客様の選択',
        行业解决方案: '業界向けソリューション',
        请输入您的电话号码: '電話番号を入力してください',
        预约回电: '予約返電',
        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: '専門的なプリセールスとアフターサービスを提供することで、国境を越えた旅を簡単に始めることができます',
        杭州国播优选科技有限公司: '杭州国播優選科技有限公司',
        地址: '6th Floor, Building 5, No. 6 Wangsheng Road, Linping District, Hangzhou City, Zhejiang Province (Whole Floor)',
        国播优选官方微信号: '国営放送の好ましい公式マイクロ信号',
        为品牌海外业绩增长提供全方位资源和服务: 'ブランドの海外業績の増加に全方位の資源とサービスを提供する',
        用户案例: 'ユーザー事例',
        解决方案: 'ソリューション',
        娱乐平台: 'エンターテインメントプラットフォーム',
        家用电器: '家電製品',
        游戏直播: 'ゲームの生放送',
        教育培训: '教育訓練',
        服饰用品: '服飾品',
        知识付费: '知識の支払い',
        水晶珠宝: 'クリスタルジュエリー',
        宏冠赛鸽: '宏冠サイドバト',
        致力为您提供专业的服务与支持: '専門的なサービスとサポートの提供に努めます',
        系统搭建: 'システム構築',
        AI模型: 'AIモデル',
        视频编程: 'ビデオプログラミング',
        语音翻译: '音声翻訳',
        全方位提供支持服务: '音声翻訳の全方位的なサポートサービス',
        产品使用指导技术问题解答: '音声翻訳による全方位的なサポートサービス提供製品使用指導技術に関する質問への回答',
        客户需求为先: 'お客様のニーズを優先',
        从满足客户需求到创造客户价值: 'お客様のニーズを満たすことからお客様の価値を創造することまで',
        落地有保障: '着地には保障がある',
        专业团队为您出海赋能: '専門チームがあなたのために海に出てエネルギーを供給します',
        极速服务应答: '極速サービス応答',
        小时响应724小时保驾护航: '時間対応724時間パイロット',
        加盟合作共享品牌价值与发展机遇: '加盟協力によるブランド価値と発展のチャンスの共有',
        代理合作: '代理業務',
        平台合作: 'プラットフォーム連携',
        技术合作: '技術協力',
        供应链合作: '技術協力サプライチェーン協力',
        合作流程: 'コラボレーションプロセス',
        客户需求沟通: '顧客ニーズのコミュニケーション',
        方案规划: 'シナリオ計画',
        确认需求: '要件の確認',
        专业指导: '専門的なガイダンス',
        跑通流程: 'ランニングフロー',
        项目收尾: 'プロジェクトの終了',
        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: 'お客様は、デルと手を携えて無限の可能性を開拓するために、次の方法で迅速に連絡することができます。',
        热线联系: 'ホットライン',
        请联系我们寻求帮助: 'お問い合わせください',
        我们将尽快为您提供帮助: 'できるだけ早くお手伝いします',
        关于我们的内容: '国際的な先進的な言語認識技術、先進的な合流技術、自主革新、アリババ技術サポート、ヨーロッパのトップモデル訓練技術を強化し、成熟したソフトウェア開発チームを持っている。創設チームはインターネット情報技術の分野を深く耕し、アリ、テンセント、360などの国内有名企業と緊密なパートナーシップを築いてきた。私たちは「革新、真実を求め、誠実で、奮闘する」という職業精神を受け継ぎ、豊富な業界経験と専門技術を持っています。私たちは毎回の協力の機会と挑戦を尊重し、品質と自己超越を追求し、業界の上下流資源の優位性に頼って、私たちはユーザーに優れたソリューションと親切なサービスを提供することができ、そして巨大なビジネス価値と社会価値をもたらすと信じています。',
        公司简介: '会社概要',
        我们的优势: 'デルの強み',
        技术优势: '技術上の利点',
        技术支持内容: '国際的な先進的な言語認識技術、先進的な合流技術、自主革新、アリババ技術サポート、ヨーロッパのトップモデル訓練技術を強化し、成熟したソフトウェア開発チームを持っている。',
        顶尖团队: 'トップチーム',
        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: '国際トップ技術チーム国家千人計画技術リード国内トップクロスボーダー運営チーム経験豊富資源充満杭州対外貿易クロスボーダー協会加持',
        低成本: '低コス',
        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: 'デルのサービスに費用を払うだけで競争力のある価格マッチング戦略は、デルのソリューションを利用して大きな収益を得ることができることを意味します',
        全球覆盖: 'グローバル・カバレッジ',
        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: 'デルは、製品やサービスの信頼性の高い供給を確保し、さまざまな地域のニーズに対応する効率的なサプライチェーンシステムを世界規模で構築しています。'
    },
    // 韩语
    SouthKorea: {
        首页: '첫 페이지',
        产品介绍: '제품 소개',
        技术支持: '기술 지원',
        商务合作: '비즈니스 협력',
        关于我们: '우리에 대해',
        产品下载: '제품 다운로드',
        相关工具下载: '관련 도구 다운로드',
        海外电商语言解决方案服务平台: "해외 전자상거래 언어 솔루션 서비스 플랫폼",
        全语言全品类全场景: '해외 전자상거래 언어 솔루션 서비스 플랫폼 전 언어 전 품목 전 장면',
        联系客服: '고객 서비스에 문의',
        为用户提供高效专业的项目和服务: '사용자에게 효율적이고 전문적인 프로젝트 및 서비스 제공',
        助力产品出海升级转型: '제품의 출항 업그레이드 전환을 돕다',
        开启海外电商新模式: '해외 전자상거래의 새로운 모델을 열다',
        首页内容: "우리는 사용자에게 원스톱 실시간 언어 번역 솔루션을 제공하고, 공급망 판매 영향자, 인공지능 번역을 통합한 서비스 플랫폼을 구축하여 사용자가 언어 장애를 타파하고, 실시간 음성 교류, 온라인 상호작용을 실현하도록 돕는다. 예를 들면 좋은 것을 공유하는 것이다.실시간 번역, 보조 방송 번역 및 모바일 게임 번역과 같은 다양한 번역 응용 프로그램 시나리오가 있습니다.다양한 국가 및 지역의 180개 주요 언어를 지원합니다.현재 틱톡, 인스타그램, 유튜브, 왓츠앱, 라인, 페이스북 등 해외 주류 플랫폼과 호환된다.우리의 플랫폼을 통해 직접적이든 우리는 제품 홍보, 온라인 교육 및 생방송에 고품질의 언어 솔루션을 제공하여 사용자들이 그들의 수준 전시, 글로벌 시장을 확대하고 경쟁력을 높일 수 있도록 도울 수 있다.우리를 선택하여 무한한 가능성을 열어라",
        一站式解决方案: '원스톱 솔루션',
        助力品牌出海: '조력 브랜드 출항',
        互动数据打造直播能手跨境利器: '인터렉티브 데이터 생방송 능수, 크로스보더 이기, 브랜드 출항 조력 -"인터렉션 + 데이터","생방송 능수, 크로스보더 이기를 만들다',
        开发经验: '개발 경험',
        覆盖行业: '적용 대상 업종',
        客户选择: '고객 선택',
        行业解决方案: '업계 솔루션',
        请输入您的电话号码: '업계 솔루션 전화 번호 입력',
        预约回电: '예약 회신',
        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: '우리는 당신이 쉽게 국경을 넘어 여행할 수 있도록 전문적인 판매 전 및 애프터서비스를 제공합니다.',
        杭州国播优选科技有限公司: '항주국파우선과학기술유한공사',
        地址: '항주국파우선과학기술유한회사 절강성 항주시 림평구 왕성로 6호 5동 6층 (전층)',
        国播优选官方微信号: '국가 방송 우선 공식 마이크로 신호 ',
        为品牌海外业绩增长提供全方位资源和服务: '브랜드의 해외 실적 증가에 전방위적인 자원과 서비스를 제공하다',
        用户案例: '사용자 사례',
        解决方案: '솔루션',
        娱乐平台: '엔터테인먼트 플랫폼',
        家用电器: '가전제품',
        游戏直播: '게임 방송',
        教育培训: '교육 훈련',
        服饰用品: '의류 용품',
        知识付费: '지식 비용 지불',
        水晶珠宝: '크리스털 보석',
        宏冠赛鸽: '홍관 경기 비둘기 ',
        致力为您提供专业的服务与支持: '전문적인 서비스 및 지원 제공',
        系统搭建: '시스템 구축',
        AI模型: 'AI 모델',
        视频编程: '비디오 프로그래밍',
        语音翻译: '음성 번역',
        全方位提供支持服务: '광범위한 지원 서비스 제공',
        产品使用指导技术问题解答: '제품 사용 지침 기술 문제 해결',
        客户需求为先: '고객 요구 사항 우선',
        从满足客户需求到创造客户价值: '고객 요구 사항 충족에서 고객 가치 창출까지',
        落地有保障: '착지가 보장되다',
        专业团队为您出海赋能: '전문 팀이 당신을 위해 바다로 나가 능력을 부여하다',
        极速服务应答: '초고속 서비스 응답',
        小时响应724小时保驾护航: '1시간 응답 7 * 24시간 보호',
        加盟合作共享品牌价值与发展机遇: '가맹 합작은 브랜드 가치와 발전 기회를 공유한다.',
        代理合作: '대리 협력',
        平台合作: '플랫폼 협력',
        技术合作: '기술 협력',
        供应链合作: '공급망 협력',
        合作流程: '협력 프로세스',
        客户需求沟通: '고객 요구 사항 커뮤니케이션',
        方案规划: '시나리오 계획',
        确认需求: '요구 사항 확인',
        专业指导: '전문 지도',
        跑通流程: '패스 프로세스',
        项目收尾: '프로젝트 마무리',
        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: '귀하는 다음과 같은 방법으로 우리에게 신속하게 연락할 수 있습니다. 우리는 함께 협력하여 시장을 개척할 수 있습니다',
        热线联系: '핫라인 연결',
        请联系我们寻求帮助: '도움을 요청하려면 문의하십시오.',
        我们将尽快为您提供帮助: '가능한 한 빨리 도움을 드리겠습니다.',
        关于我们的内容: '창립팀은 줄곧 인터넷정보기술령역을 깊이 경작해왔으며 알리, 텐센트, 360 등 국내 유명기업과 긴밀한 협력동반자관계를 구축했다.우리는"혁신, 실사구시, 신의성실, 분투"의 직업정신을 계승하여 풍부한 업종경험과 전문기술을 갖고있다.우리는 매번 합작의 기회와 도전을 존중하고 품질과 자아초월을 추구하며 업계내의 상하류자원의 우세에 의거하여 우리는 사용자에게 뛰여난 해결방안과 친절한 서비스를 제공할수 있으며 거대한 상업가치와 사회가치를 가져다줄것이라고 믿는다.',
        公司简介: '회사 소개',
        我们的优势: '우리의 강점',
        技术优势: '기술적 이점',
        技术支持内容: '기술 우위 국제 선두 언어 식별 기술, 선진 합류 기술, 자주적 혁신, 알리바바 기술 지지, 유럽 최고 모델 훈련 기술 추가, 성숙한 소프트웨어 개발 팀을 보유하고 있다.',
        顶尖团队: '최고 팀',
        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: '국제 최고 기술팀 국가 천인 계획 기술 선도 국내 헤드 크로스보더 운영팀 경험 풍부 자원 충족 항주 대외무역 크로스보더 협회 추가',
        低成本: '저비용',
        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: '서비스 비용만 지불하면 됩니다. 경쟁력 있는 가격 매칭 전략은 당신이 우리의 방안을 통해 막대한 수익을 얻을 수 있다는 것을 의미합니다.',
        全球覆盖: '글로벌 커버리지',
        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: '전 세계에 걸쳐 효율적인 공급망 시스템을 구축하여 제품 또는 서비스의 신뢰할 수 있는 공급 및 지역별 요구 사항 충족'
    },
    // 泰语
    Thai: {
        首页: 'หน้าหลัก',
        产品介绍: 'แนะนำผลิตภัณฑ์',
        技术支持: 'การสนับสนุนทางเทคนิค',
        商务合作: 'ความร่วมมือทางธุรกิจ',
        关于我们: 'เกี่ยวกับเรา',
        产品下载: 'ดาวน์โหลดผลิตภัณฑ์',
        相关工具下载: 'ดาวน์โหลดเครื่องมือ ที่เกี่ยวข้อง',
        海外电商语言解决方案服务平台: "แพลตฟอร์มบริการภาษาอีคอมเมิร์ซในต่างประเทศ",
        全语言全品类全场景: 'เต็ม ภาษา เต็ม หมวดหมู่ เต็ม ที่เกิดเหตุ',
        联系客服: 'ติดต่อฝ่ายบริการลูกค้า',
        为用户提供高效专业的项目和服务: 'โครงการและบริการที่มีประสิทธิภาพและเป็นมืออาชีพสำหรับผู้ใช้',
        助力产品出海升级转型: 'ช่วยให้ผลิตภัณฑ์ออกทะเลเพื่ออัพเกรดและเปลี่ยนแปลง',
        开启海外电商新模式: 'เปิดโมเดลใหม่ของอีคอมเมิร์ซในต่างประเทศ',
        首页内容: "เรามุ่งมั่นที่จะนำเสนอโซลูชั่นการแปลภาษาแบบเรียลไทม์แบบครบวงจรสำหรับผู้ใช้สร้างผู้มีอิทธิพลด้านการขายในห่วงโซ่อุปทานแพลตฟอร์มบริการที่รวมการแปล AI เพื่อช่วยให้ผู้ใช้ทำลายอุปสรรคทางภาษาและบรรลุการสื่อสารด้วยเสียงแบบเรียลไทม์ปฏิสัมพันธ์ออนไลน์เช่นการแบ่งปันสิ่งที่ดี เรามีสถานการณ์การแปลที่หลากหลายเช่นการแปลแบบเรียลไทม์การแปลออกอากาศช่วยและการแปลเกมมือถือ ฯลฯ รองรับภาษาหลัก 180 ภาษาในประเทศและภูมิภาคต่างๆ ปัจจุบันแพลตฟอร์มหลักในต่างประเทศ เช่น TikTok, Instagram, YouTube, WhatsApp, Line และ Facebook เข้ากันได้ ด้วยแพลตฟอร์มของเราไม่ว่าจะโดยตรงเราสามารถให้บริการโซลูชั่นภาษาคุณภาพสูงสำหรับการส่งเสริมผลิตภัณฑ์การศึกษาออนไลน์และการถ่ายทอดสดช่วยให้ผู้ใช้ขยายการแสดงระดับตลาดโลกและเพิ่มความสามารถในการแข่งขัน เลือกเราและเปิดความเป็นไปได้ที่ไม่มีที่สิ้นสุด",
        一站式解决方案: 'โซลูชันแบบครบวงจร',
        助力品牌出海: 'ช่วยแบรนด์ออกทะเล',
        互动数据打造直播能手跨境利器: 'ข้อมูลเชิงโต้ตอบสร้างผู้เชี่ยวชาญด้านการถ่ายทอดสดข้ามพรมแดน',
        开发经验: 'ประสบการณ์การพัฒนา',
        覆盖行业: 'ครอบคลุมอุตสาหกรรม',
        客户选择: 'ทางเลือกของลูกค้า',
        行业解决方案: 'โซลูชั่นอุตสาหกรรม',
        请输入您的电话号码: 'กรุณากรอกหมายเลขโทรศัพท์',
        预约回电: 'นัดหมายเพื่อโทรกลับ',
        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: 'เราให้บริการก่อนการขายและหลังการขายอย่างมืออาชีพเพื่อช่วยให้คุณเริ่มต้นการเดินทางข้ามพรมแดนได้อย่างง่ายดาย',
        杭州国播优选科技有限公司: 'หางโจว Guocast ชอบเทคโนโลยี จำกัด',
        地址: 'ชั้น 6 อาคาร 5 เลขที่ 6 ถนน Wangsheng เขต Linping เมืองหางโจวจังหวัดเจ้อเจียง (ทั้งชั้น)',
        国播优选官方微信号: 'Guocast ต้องการ WeChat อย่างเป็นทางการ ',
        为品牌海外业绩增长提供全方位资源和服务: 'ทรัพยากรและบริการเต็มรูปแบบสำหรับการเติบโตของแบรนด์ในต่างประเทศ',
        用户案例: 'กรณีผู้ใช้',
        解决方案: 'วิธีการแก้ปัญหา',
        娱乐平台: 'แพลตฟอร์มความบันเทิง',
        家用电器: 'เครื่องใช้ในบ้าน',
        游戏直播: 'เกมสด',
        教育培训: 'การศึกษาและการฝึกอบรม',
        服饰用品: 'เสื้อผ้าสำเร็จรูป',
        知识付费: 'ความรู้จ่าย',
        水晶珠宝: 'เครื่องประดับคริสตัล',
        宏冠赛鸽: 'นกพิราบแข่งมงกุฎแมโคร',
        致力为您提供专业的服务与支持: 'มุ่งมั่นที่จะให้บริการและการสนับสนุนอย่างมืออาชีพ',
        系统搭建: 'การสร้างระบบ',
        AI模型: 'โมเดล AI',
        视频编程: 'การเขียนโปรแกรมวิดีโอ',
        语音翻译: 'การแปลเสียง',
        全方位提供支持服务: 'มีบริการสนับสนุนอย่างครบวงจร',
        产品使用指导技术问题解答: 'คำแนะนำการใช้ผลิตภัณฑ์ คำตอบสำหรับคำถามทางเทคนิค',
        客户需求为先: 'ความต้องการของลูกค้าก่อน',
        从满足客户需求到创造客户价值: 'ตั้งแต่การตอบสนองความต้องการของลูกค้า ไปจนถึงการสร้างมูลค่าให้กับลูกค้า',
        落地有保障: 'รับประกันการลงพื้น',
        专业团队为您出海赋能: 'ทีมงานมืออาชีพที่จะออกทะเลเพื่อเพิ่มขีดความสามารถของคุณ',
        极速服务应答: 'การตอบสนองบริการที่รวดเร็ว',
        小时响应724小时保驾护航: 'การตอบสนอง 1 ชั่วโมง, การป้องกันและการป้องกัน 7 * 24 ชั่วโมง',
        加盟合作共享品牌价值与发展机遇: 'การร่วมมือกับแฟรนไชส์เพื่อแบ่งปันคุณค่าของแบรนด์และโอกาสในการพัฒนา',
        代理合作: 'ความร่วมมือตัวแทน',
        平台合作: 'ความร่วมมือแพลตฟอร์ม',
        技术合作: 'ความร่วมมือทางเทคนิค',
        供应链合作: 'ความร่วมมือด้านซัพพลายเชน',
        合作流程: 'กระบวนการความร่วมมือ',
        客户需求沟通: 'การสื่อสารความต้องการของลูกค้า',
        方案规划: 'การวางแผนการแก้ปัญหา',
        确认需求: 'การยืนยันความต้องการ',
        专业指导: 'คำแนะนำอย่างมืออาชีพ',
        跑通流程: 'ตลอดกระบวนการ',
        项目收尾: 'สิ้นสุดโครงการ',
        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: 'การเป็นพันธมิตรเพื่อแบ่งปันคุณค่าของแบรนด์และโอกาสในการพัฒนาคุณสามารถติดต่อเราได้อย่างรวดเร็วด้วยวิธีต่อไปนี้และเราจะสำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุดของตลาดด้วยกัน',
        热线联系: '热线联系',
        请联系我们寻求帮助: 'กรุณาติดต่อเราเพื่อขอความช่วยเหลือ',
        我们将尽快为您提供帮助: 'เราจะช่วยคุณโดยเร็วที่สุด',
        关于我们的内容: 'เราจะช่วยคุณโดยเร็วที่สุด ทีมผู้ก่อตั้งเจาะลึกพื้นที่เทคโนโลยีสารสนเทศทางอินเทอร์เน็ตและสร้างความร่วมมืออย่างใกล้ชิดกับ บริษัท ที่มีชื่อเสียงในประเทศเช่นอาลีบาบาเทนเซ็นต์และ 360 เรายึดมั่นในความเป็นมืออาชีพของ "นวัตกรรมในทางปฏิบัติความซื่อสัตย์และการทำงาน" ด้วยประสบการณ์ในอุตสาหกรรมที่หลากหลายและทักษะมืออาชีพ เราเคารพโอกาสและความท้าทายของความร่วมมือทุกครั้งการแสวงหาคุณภาพและการเหนือกว่าตนเองอาศัยข้อได้เปรียบของทรัพยากรต้นน้ำและปลายน้ำของอุตสาหกรรม เราเชื่อว่าเราสามารถให้บริการโซลูชั่นที่ยอดเยี่ยมและบริการที่เอาใจใส่แก่ผู้ใช้และจะนำมาซึ่งคุณค่าทางธุรกิจและสังคมที่ดี',
        公司简介: 'ข้อมูล บริษัท',
        我们的优势: 'ข้อดีของเรา',
        技术优势: 'ข้อได้เปรียบทางเทคนิค',
        技术支持内容: 'ข้อได้เปรียบทางเทคโนโลยี เทคโนโลยีการจดจำภาษาชั้นนำระดับนานาชาติเทคโนโลยีการผสมผสานขั้นสูงนวัตกรรมที่เป็นอิสระการสนับสนุนทางเทคนิคของอาลีบาบาการสนับสนุนด้านเทคนิคการฝึกอบรมโมเดลชั้นนำในยุโรปมีทีมพัฒนาซอฟต์แวร์ที่เป็นผู้ใหญ่',
        顶尖团队: 'ทีมยอดนิยม',
        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: 'ทีมงานด้านเทคนิคชั้นนำระดับนานาชาติซึ่งเป็นผู้นำด้านวิทยาศาสตร์และเทคโนโลยีแห่งชาติหลายพันคน ทีมปฏิบัติการข้ามพรมแดนชั้นนำที่มีประสบการณ์และทรัพยากรในประเทศซึ่งได้รับการสนับสนุนจากสมาคมการค้าข้ามพรมแดนเมืองหางโจว',
        低成本: 'ต้นทุนต่ำ',
        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: 'เพียงชำระเงินสำหรับบริการของเรา กลยุทธ์การจับคู่ราคาที่แข่งขันได้ของเราหมายความว่าคุณจะได้รับผลกำไรมหาศาลจากโซลูชั่นของเรา',
        全球覆盖: 'ครอบคลุมทั่วโลก',
        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: 'เราสร้างระบบห่วงโซ่อุปทานที่มีประสิทธิภาพทั่วโลกเพื่อให้แน่ใจว่าการจัดหาผลิตภัณฑ์หรือบริการที่เชื่อถือได้และตอบสนองความต้องการของภูมิภาคต่างๆ'
    },
    // 马来西亚
    Malaysia: {
        首页: 'homePage',
        产品介绍: 'HomepageProduct Introduction',
        技术支持: 'sokongan teknikal',
        商务合作: 'Persatuan',
        关于我们: 'About Us',
        产品下载: 'Muat turun produk',
        相关工具下载: 'Muat turun alat berkaitan',
        海外电商语言解决方案服务平台: "About China Broadcasting's Optimal Official WeChat Signal Overseas E - Commerce Language Solution Platform",
        全语言全品类全场景: 'Semua bahasa, kategori, dan skenario',
        联系客服: 'perkhidmatan pelanggan',
        为用户提供高效专业的项目和服务: 'Hubungi perkhidmatan pelanggan untuk menyediakan projek dan perkhidmatan efisien dan profesional bagi pengguna',
        助力产品出海升级转型: 'Bantu dalam meningkatkan dan mengubah produk di luar negeri',
        开启海外电商新模式: 'Buka model baru e-commerce luar negeri',
        首页内容: "Kami berkomitmen untuk menyediakan penyelesaian terjemahan bahasa pada masa sebenar satu hentian untuk mencipta pengaruh rantai bekalan untuk jualan,Platform perkhidmatan yang melibatkan terjemahan AI untuk membantu pengguna menghancurkan halangan bahasa dan mencapai komunikasi suara pada masa sebenar, interaksi secara talian Features seperti berkongsi item baik.Kami mempunyai skenario aplikasi terjemahan berbilang, seperti nyata - terjemahan masa, terjemahan siaran yang diberi bantuan, dan terjemahan permainan bimbit Etc. menyokong 180 bahasa utama di negara dan kawasan yang berbeza. Pada masa ini, platforma utama luar negeri seperti TikTok, Instagram YouTube, WhatsApp, Line, dan Facebook semua sesuai. Melalui platform kita, sama ada ia langsung kita boleh menyediakan solusi bahasa berkualiti tinggi untuk promosi produk, pendidikan online, dan streaming langsung untuk membantu pengguna mengembangkan horizon mereka Exhibition, pasar global, dan meningkatkan kepekatan. Pilih kami dan buka kemungkinan tak terbatas ",
        一站式解决方案: 'Solusi satu-henti',
        助力品牌出海: 'membantu markah menjadi global',
        互动数据打造直播能手跨境利器: 'interaktif + data" untuk mencipta "ahli aliran langsung, alat melintasi sempadan',
        开发经验: 'Pengalaman pembangunan',
        覆盖行业: 'Penutupan industri',
        客户选择: 'Pemilihan pelanggan',
        行业解决方案: 'Solusi industri',
        请输入您的电话号码: 'Sila masukkan nombor telefon anda',
        预约回电: 'Make an appointment for a call back',
        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: 'Jadikanlah perjanjian untuk panggilan semula',
        杭州国播优选科技有限公司: 'Hangzhou Guobo Youxuan Technology Co., Ltd',
        地址: 'Tingkat 6, Bangunan 5, No. 6 Wangsheng Road, Linping District, Hangzhou City, Zhejiang Province (Whole Floor)',
        国播优选官方微信号: 'Akaun WeChat rasmi Pemilihan Optimal Guobo',
        为品牌海外业绩增长提供全方位资源和服务: 'Memberikan sumber dan perkhidmatan yang meliputi untuk pertumbuhan prestasi tanda di luar negeri',
        用户案例: 'Cerita Pengguna',
        解决方案: 'Solution',
        娱乐平台: 'Platform hiburan',
        家用电器: 'peralatan rumah',
        游戏直播: 'game live streaming',
        教育培训: 'pendidikan dan latihan',
        服饰用品: 'pakaian dan aksesori',
        知识付费: 'pembayaran pengetahuan',
        水晶珠宝: 'perhiasan kristal',
        宏冠赛鸽: 'Merpati balapan Hongguan ',
        致力为您提供专业的服务与支持: 'Didedikasikan untuk memberikan anda perkhidmatan profesional dan sokongan ',
        系统搭建: 'Setup sistem',
        AI模型: 'Model AI',
        视频编程: 'Program Video',
        语音翻译: 'terjemahan suara',
        全方位提供支持服务: 'menyediakan perkhidmatan sokongan dalam semua aspek',
        产品使用指导技术问题解答: 'panduan penggunaan produk dan penyelesaian masalah teknikal',
        客户需求为先: 'pelanggan perlukan pertama',
        从满足客户需求到创造客户价值: 'dari memenuhi pelanggan untuk mencipta nilai pelanggan',
        落地有保障: 'memastikan pelaksanaan',
        专业团队为您出海赋能: 'pasukan profesional yang memungkinkan anda untuk menjadi global',
        极速服务应答: 'Balasan perkhidmatan cepat',
        小时响应724小时保驾护航: '1 jam balas, 7 * 24 jam perlindungan dan perlindungan ',
        加盟合作共享品牌价值与发展机遇: 'Perusahaan Franchise, berkongsi nilai tanda dan peluang pembangunan',
        代理合作: 'Agen kerjasama',
        平台合作: 'Persatuan Platform',
        技术合作: 'Kooperasi teknologi',
        供应链合作: 'Persatuan rantai bekalan',
        合作流程: 'Proses kerjasama',
        客户需求沟通: 'Komunikasi permintaan pelanggan',
        方案规划: 'Perrancangan penyelesaian',
        确认需求: 'Pengesahan permintaan',
        专业指导: 'Pemanduan profesional',
        跑通流程: 'Melalui proses',
        项目收尾: 'Penutupan projek',
        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: 'Perusahaan Franchise, berkongsi nilai tanda dan peluang pembangunan Anda boleh dengan cepat menghubungi kami melalui kaedah berikut, dan kami akan bekerja sama untuk mengeksplorasi kemungkinan tidak terbatas di pasar',
        热线联系: 'Kenalan garis panas',
        请联系我们寻求帮助: 'Sila hubungi kami untuk bantuan',
        我们将尽快为您提供帮助: 'Sesungguhnya Kami akan memberikan pertolongan kepada kamu secepat mungkin',
        关于我们的内容: 'Kami akan memberikan bantuan kepada anda secepat mungkin. Pasukan pendiri telah terlibat dalam bidang teknologi maklumat internet dan telah menetapkan persahabatan dekat dengan perusahaan rumah yang dikenali seperti Alibaba, Tencent, dan 360. Kami mematuhi semangat profesional "inovasi, pragmatisme, integriti, dan kerja keras", dan mempunyai pengalaman industri yang kaya dan kemahiran profesional. Kami menghormati setiap peluang dan cabaran kerjasama, mengejar kualiti dan transcendence diri, dan bergantung pada keuntungan sumber upstream dan downstream dalam industri. Kami percaya bahawa kita boleh menyediakan penyelesaian yang baik dan perkhidmatan yang berfikiran kepada pengguna, dan akan membawa nilai komersial dan sosial yang besar',
        公司简介: 'Profil Syarikat',
        我们的优势: 'Kekuatan kita',
        技术优势: 'Keuntungan teknikal',
        技术支持内容: 'Teknologi pengenalan bahasa utama antarabangsa, teknologi konvergensi maju, inovasi independen,sokongan teknik Alibaba, disokong oleh teknologi latihan model Eropah terbaik, mempunyai pasukan pembangunan perisian Mature ',
        顶尖团队: 'Pasukan terbaik',
        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: 'Pasukan teknikal antarabangsa terbaik, memimpin Program Ribuan Talent Nasional dalam teknologi; Pasukan operasi melintasi sempadan rumah yang memimpin dengan pengalaman yang kaya dan sumber yang banyak, disokong oleh Asosiasi Perdagangan Sempadan Hangzhou',
        低成本: 'biaya rendah',
        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: 'Hanya membayar untuk perkhidmatan kami, strategi pertandingan harga kami bermakna anda boleh mendapatkan keuntungan besar dengan penyelesaian kami ',
        全球覆盖: 'Penutupan Global',
        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: 'Kami telah menetapkan sistem rantai bekalan efisien di seluruh dunia untuk memastikan bekalan yang boleh dipercayai produk atau perkhidmatan dan memenuhi keperluan kawasan yang berbeza'
    },
    // 菲律宾
    Filipino: {
        首页: ' home Page',
        产品介绍: ' Homepage Product Introduction',
        技术支持: ' Technical Support',
        商务合作: ' Kooperasyon',
        关于我们: ' Tungkol sa atin',
        产品下载: 'Mga pag download ng produkto',
        相关工具下载: 'Mga kaugnay na tool download',

        海外电商语言解决方案服务平台: "Tungkol sa Optimal Official WeChat Signal ng Tsina Broadcasting Overseas E - commerce Language Solution Service Platform",

        全语言全品类全场景: ' Lahat ng wika, kategorya, at pangyayari',

        联系客服: ' customer service',

        为用户提供高效专业的项目和服务: ' Makipag-ugnayan ang serbisyo ng mga customer upang magbigay ng mga proyektong at serbisyo na epektibo at propesyonal para sa mga user',

        助力产品出海升级转型: ' Tulungan sa pag-upgrade at pagbabago ng mga produkto sa ibang bansa',

        开启海外电商新模式: ' Buksan ang bagong modelo ng e-commerce sa ibang bansa',

        首页内容: "Kami ay nakatuon sa pagbibigay sa mga user ng isang solusyon sa pagsasalinwika ng wika sa real-time upang lumikha ng isang epekto sa katina ng pagbibigay para sa mga benta,isang platapormang serbisyo na nagsasalinwika ng AI upang makatulong sa mga user sa pagsira ng mga hadlang sa wika at makamit ng real-time voice communication, online interaction Karakteristika tulad ng pagbabahagi ng mga magandang item. pagsasalinwika ng oras, tulong na pagsasalinwika ng pagsasalinwika, at pagsasalinwika ng mobile laro Etc. na sumusuporta sa 180 pangunahing wika sa iba't ibang bansa at rehiyon. Sa kasalukuyan, ang mga mainstream platform sa ibang bansa tulad ng TikTok, Instagram YouTube, WhatsApp, Line at Facebook ay kumpatible. Sa pamamagitan ng aming plataporma, kung ito ay direkta Maaari naming magbigay ng mga solusyon sa wika ng mataas na kwalidad para sa promosyon ng mga produkto, online na edukasyon, at live streaming upang makatulong sa mga user na palawakin ang kanilang horizonsExhibition, global market, at pagpapataas ng kapangyarihan. Piliin tayo at unlock ang walang hanggan posibilidad ",

        一站式解决方案: ' Isang-stop na solusyon',

        助力品牌出海: ' tumulong sa mga markang pandaigdigan',

        互动数据打造直播能手跨境利器: ' "interactive + data" upang lumikha ng "live streaming experts, transboundary tools"',

        开发经验: ' karanasan sa pag-unlad',

        覆盖行业: ' Industry coverage',

        客户选择: ' Mga customer selection',

        行业解决方案: ' Mga solusyon ng industriya',

        请输入您的电话号码: ' Pakiusap ipasok ang iyong numero ng telepono ',

        预约回电: ' Gumawa ng appointment para sa call back ',

        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: ' Nagbibigay tayo sa inyo ng mga propesyonal na serbisyo para sa pagbebenta at pagkatapos ng pagbebenta upang makatulong ka sa madaling magsimula sa iyong paglalakbay sa ibabaw ng hangganan',

        杭州国播优选科技有限公司: ' Hangzhou Guobo Youxuan Technology Co., Ltd',

        地址: ' 6th Floor, Building 5, No. 6 Wangsheng Road, Linping District, Hangzhou City, Zhejiang Province (Whole Floor)',

        国播优选官方微信号: ' Official WeChat account of Guobo Optimal Selection ',

        为品牌海外业绩增长提供全方位资源和服务: ' Magbigay ng komprensong pagkukunan at serbisyo para sa paglaki ng mga marka sa ibang bansa',

        用户案例: ' Mga User Stories',

        解决方案: ' Solution',

        娱乐平台: ' Entertainment platform',

        家用电器: ' home appliances',

        游戏直播: ' game live streaming',

        教育培训: ' edukasyon at training',

        服饰用品: ' damit at mga kasangkapan',

        知识付费: ' pagbayad ng kaalaman',

        水晶珠宝: ' kristal jewelry',

        宏冠赛鸽: ' Hongguan racing pigeon ',

        致力为您提供专业的服务与支持: ' Binabagay sa pagbibigay ng propesyonal na serbisyo at suporta',

        系统搭建: ' System setup ',

        AI模型: ' AI model',

        视频编程: ' Video programming',

        语音翻译: ' voice translation',

        全方位提供支持服务: ' na nagbibigay ng suporta sa lahat ng aspeto',

        产品使用指导技术问题解答: ' gamitin ng produkto at paglutas ng mga problema',

        客户需求为先: ' una ang kailangan ng mga kustomer',

        从满足客户需求到创造客户价值: ' mula sa pagtugon sa mga kailangan ng mga customer hanggang sa paglikha ng halaga ng mga customer',

        落地有保障: ' na siguraduhin ang pagpapatupad',

        专业团队为您出海赋能: ' ang propesyonal na grupo na nagpapalakas sa iyo upang maging pandaigdigan',

        极速服务应答: ' Mabilis na serbisyo',

        小时响应724小时保驾护航: ' Isang oras na sagot, 7 * 24 oras na proteksyon at proteksyon',

        加盟合作共享品牌价值与发展机遇: ' Pagtutulungan sa Franchise, pagbabahagi ng halaga ng marka at pagkakataon ng pag-unlad',

        代理合作: ' Agent cooperation',

        平台合作: ' Kooperasyon sa plataporma',

        技术合作: ' Kasama sa teknolohiya',

        供应链合作: ' Kooperasyon sa supply chain',

        合作流程: ' Proses ng pakikipagtulungan',

        客户需求沟通: ' Kummunikasyon sa Customer demand',

        方案规划: ' Pagpaplano ng solusyon',

        确认需求: ' Confirmation of demand',

        专业指导: ' Professional guidance',

        跑通流程: ' Sa pagpapatakbo ng proseso',

        项目收尾: ' Pagsasara ng proyekto',

        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: ' Pagkausap sa Franchise, pagbabahagi ng halaga ng marka at pagkakataong pag-unlad Maaari mong mabilis makipag-ugnay sa amin sa pamamagitan ng mga sumusunod na pamamaraan, at magkakasama tayo upang imbestigahan ang walang hanggan na posibilidad sa market ',

        热线联系: ' Hotline contact',
        请联系我们寻求帮助: 'Please contact us for assistance',
        我们将尽快为您提供帮助: ' Bibigyan namin sa iyo ng tulong sa lalong madaling panahon',

        关于我们的内容: ' Magbibigay kami ng tulong sa iyo sa lalong madaling panahon. Naging malalim na kasangkot ang grupong nagtatag sa larangan ng teknolohiyang pang-internet ng impormasyon at gumawa ng malapit na ugnayan sa mga kilalang pambansang negosyo tulad ng Alibaba, Tencent at 360. Tinutukoy namin ang espiritu ng propesyonal na "innovación, pragmatismo, integridad, at mahirap na trabaho", at may mayaman na karanasan sa industriya at mga propesyonal na kakayahan. Nirerespeto natin ang bawat pagkakataon at hamon ng pakikipagtulungan, patuloy natin ang kwalidad at paglilibang sa sarili, at umaasa sa mga bentahe ng mga enerhiya sa taas at pababa sa industriya. Naniniwala tayo na maaari tayong magbigay ng mahusay na solusyon at mapanlikha ng serbisyo sa mga gumagamit, at magdadala ng malaking commercial at social value',

        公司简介: ' Company Profile',

        我们的优势: ' Ang ating mga strengths',

        技术优势: ' Technical advantages',

        技术支持内容: ' Mature software development team ',

        顶尖团队: ' top team',

        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: ' Ang pinakamataas na pang-internasyonal na koponan ng teknolohiya, na pinuno ng National Thousand Talents Program sa teknolohiya; Isang pinakamahalagang grupo ng mga operasyon na gumaganap sa buong hangganan, na may mayaman na karanasan at maraming pagkukunan, na suportado ng Asociasyon ng Kummersyal ng Cross-border ng Hangzhou.',

        低成本: ' mababang halaga',

        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: ' Bayaran lamang ang aming mga serbisyo, ang aming stratehiya ng pagpapaayos ng presyo ay nangangahulugan na maaari mong makakuha ng malaking profit sa aming solusyon',

        全球覆盖: ' Pandaigdigang pag-uulat',

        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: ' Binuo namin ang isang epektibong sistema ng supply chain sa buong mundo upang matiyak ang tiyak na pagbibigay ng mga produkto o serbisyo at matugunan ang mga pangangailangan ng iba’t ibang rehiyon '
    },
    // 俄语
    Russian: {
        首页: ' Домашняя страница ',

        产品介绍: ' Домашняя страница Презентация продукции ',

        技术支持: ' Техническая поддержка»',

        商务合作: ' Сотрудничество ',

        关于我们: ' О нас ',

        产品下载: 'Загрузка продукции',

        相关工具下载: 'Загрузка соответствующих инструментов',

        海外电商语言解决方案服务平台: '«О лучших официальных платформах для обслуживания иностранных языков электронной коммерции для вещания микросигналов в Китае»',

        全语言全品类全场景: ' Все языки, категории и сценарии ',

        联系客服: ' Обслуживание клиентов ',

        为用户提供高效专业的项目和服务: ' Свяжитесь с клиентом, чтобы предоставить пользователям высокоэффективные профессиональные проекты и услуги',

        助力产品出海升级转型: ' Помощь в модернизации зарубежной продукции»',

        开启海外电商新模式: ' Откройте новую модель зарубежной электронной коммерции».',

        首页内容: '«Мы стремимся предоставить пользователям единое решение для перевода языка в режиме реального времени.чтобы создать цепочку поставок для влияния продаж.Это сервисная платформа,которая интегрирует искусственный интеллект для перевода,чтобы помочь пользователям преодолеть языковой барьер,реализовать голосовое общение в режиме реального времени,интерактивность в Интернете и другие функции,делиться хорошими вещами.У нас есть несколько сценариев перевода приложений,таких как перевод в режиме реального времени Перевод времени,вспомогательный перевод вещания и перевод мобильных игр и т.д.Поддержка 180 основных языков в разных странах и регионах.В настоящее время основные зарубежные платформы,такие как TikTok,Instagram,YouTube,WhatsApp,Line и Facebook,совместимы.С помощью нашей платформы,будь то напрямую,мы предоставляем высококачественные языковые решения для продвижения продукции,онлайн - образования и прямых трансляций,помогая пользователям расширять свои горизонтальные презентации,глобальные рынки и повышать конкурентоспособность.Выберите нас,откройте бесконечные возможности',

        一站式解决方案: ' Единое решение ',

        助力品牌出海: ' Помогите бренду выйти на глобальный уровень ',

        互动数据打造直播能手跨境利器: ' "Интерактивные + данные" для создания "Прямой эфир даров, трансграничных инструментов',

        开发经验: ' Опыт развития ',

        覆盖行业: ' Охват отрасли ',

        客户选择: ' Выбор клиента»',

        行业解决方案: ' Отраслевые решения ',

        请输入您的电话号码: ' Пожалуйста, введите свой номер телефона.',

        预约回电: ' Забронируйте обратный звонок ',

        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: ' Мы предлагаем вам профессиональные предпродажные и послепродажные услуги, которые помогут вам легко начать путешествие через границу ».',
        杭州国播优选科技有限公司: ' Компания Hangzhou Goobo Priority Technology Co., Ltd.',

        地址: ' Линьпинский район, Ханчжоу, провинция Чжэцзян, Ваншэнлу, 6, 5, 6 этаж (весь этаж)',
        国播优选官方微信号: ' Предпочтительный WeChat Public',

        为品牌海外业绩增长提供全方位资源和服务: ' Предоставлять всесторонние ресурсы и услуги для роста производительности бренда за рубежом».',

        用户案例: ' Пользовательские истории»',

        解决方案: ' Решения ',

        娱乐平台: ' Развлекательная платформа ',

        家用电器: ' Бытовая электротехника ',

        游戏直播: ' Прямая трансляция игры ',

        教育培训: ' Образование и подготовка ',

        服饰用品: ' Одежда и аксессуары ',

        知识付费: ' Оплата знаний ',

        水晶珠宝: ' Хрустальные украшения»',

        宏冠赛鸽: ' Красный голубь',

        致力为您提供专业的服务与支持: ' Мы стремимся предоставить вам профессиональные услуги и поддержку».',

        系统搭建: ' Системные настройки»,Искусственный интеллект',
        模型: ' Модель ИИ ',

        视频编程: ' Видеопрограммирование ',

        语音翻译: ' Голосовой перевод ',

        全方位提供支持服务: ' Предоставляет полный спектр вспомогательных услуг»',

        产品使用指导技术问题解答: ' Руководство по использованию продукции и решение технических проблем»',

        客户需求为先: ' Потребности клиентов в первую очередь .',

        从满足客户需求到创造客户价值: ' От удовлетворения потребностей клиентов до создания ценности клиентов».',

        落地有保障: ' Обеспечить реализацию ',

        专业团队为您出海赋能: ' Профессиональная команда, которая выводит вас на глобальный ',

        极速服务应答: ' Быстрый ответ на услугу»',

        小时响应724小时保驾护航: ' 1 час отклика, 7 * 24 часа защиты и защиты»',

        加盟合作共享品牌价值与发展机遇: ' Присоединяйтесь к сотрудничеству, разделяйте ценность бренда и возможности для развития»',

        代理合作: ' Агенты сотрудничают ',

        平台合作: ' Платформа сотрудничества ',

        技术合作: ' Техническое сотрудничество»',

        供应链合作: ' Сотрудничество в цепочках поставок ',

        合作流程: ' Процесс кооперации»',

        客户需求沟通: ' Потребности клиентов в общении ',

        方案规划: ' Планирование решений ',

        确认需求: ' Подтверждение потребностей ',

        专业指导: ' Профессиональное руководство ',

        跑通流程: ' Процесс выполнения ',

        项目收尾: ' Проект окончен»',

        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: ' Присоединяйтесь к сотрудничеству, делитесь ценностями бренда и возможностями для развития Вы можете быстро связаться с нами следующим образом, и мы вместе изучим неограниченные возможности на рынке',

        热线联系: ' Контактная линия ',

        请联系我们寻求帮助: ' Пожалуйста, свяжитесь с нами за помощью .',

        我们将尽快为您提供帮助: ' Мы поможем вам в кратчайшие сроки».',

        关于我们的内容: ' Мы поможем вам как можно скорее. Команда основателей глубоко культивировала область информационных технологий Интернета и установила тесные партнерские отношения с известными отечественными компаниями, такими как Alibaba, Tencent и 360. Мы придерживаемся профессионализма « инноваций, прагматизма, честности и работы», обладаем богатым отраслевым опытом и профессиональными навыками. Мы уважаем возможности и проблемы каждого сотрудничества, стремимся к качеству и самопревосхождению, опираясь на преимущества ресурсов в отрасли вверх и вниз по течению. Мы считаем, что мы можем предоставить пользователям отличные решения и продуманные услуги, которые принесут огромную коммерческую и социальную ценность.',

        公司简介: ' Профиль компании ',

        我们的优势: ' Наши преимущества',

        技术优势: ' Технологические преимущества ',

        技术支持内容: ' Ведущие международные технологии распознавания языков, передовые технологии конвергенции, независимые инновации, техническая поддержка Alibaba, техническая поддержка лучших европейских моделей обучения, со зрелой командой разработчиков программного обеспечения',

        顶尖团队: ' Лучшая команда ',

        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: ' Лучшая международная техническая команда, ведущая национальную программу « Тысяча человек» в области науки и техники; При поддержке Ассоциации трансграничной торговли Ханчжоу, ведущая национальная трансграничная операционная команда с богатым опытом и ресурсами',

        低成本: ' Низкая себестоимость»',

        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: ' Просто платите за наши услуги, и наша конкурентоспособная стратегия ценового соответствия означает, что вы можете получить огромную прибыль от наших решений».',

        全球覆盖: ' Глобальное покрытие ',

        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: ' Мы создали эффективную систему цепочек поставок по всему миру, чтобы обеспечить надежную поставку продуктов или услуг и удовлетворить потребности различных регионов.'
    },
    // 法语
    French: {
        首页: " Page d'accueil",

        产品介绍: ' Home présentation du produit »',

        技术支持: ' Soutien technique ',

        商务合作: ' Coopération ',

        关于我们: ' À propos de nous',

        产品下载: 'Produits à télécharger',

        相关工具下载: 'Téléchargements d’outils connexes',

        海外电商语言解决方案服务平台: "À propos de la meilleure plate - forme officielle de service de solutions linguistiques de micro - signal pour le commerce électronique à l'étranger de China Broadcasting",

        全语言全品类全场景: ' Toutes les langues, catégories et scénarios',

        联系客服: ' Service à la clientèle ',

        为用户提供高效专业的项目和服务: ' Contacter le service client pour fournir aux utilisateurs des projets et des services efficaces et professionnels',

        助力产品出海升级转型: " Aide à la modernisation des produits d'outre - mer",
        开启海外电商新模式: " Ouvrir un nouveau modèle de commerce électronique à l'étranger '",

        首页内容: "«Nous nous engageons à fournir à nos utilisateurs une solution de traduction linguistique en temps réel à guichet unique et à créer un influenceur des ventes de la chaîne d 'approvisionnement. Il s'agit d 'une plate - forme de services intégrant la traduction par intelligence artificielle qui aide les utilisateurs à briser les barrières linguistiques et à permettre la communication vocale en temps réel, l'interaction en ligne, etc.pour partager des biens.Nous avons une variété de scénarios d 'application de traduction tels que la traduction en temps réel. Traduction de temps, traduction de diffusion assistée et traduction de jeux mobiles, etc., Prend en charge 180 langues principales dans différents pays et régions. Actuellement, les principales plateformes étrangères telles que tiktok, Instagram, YouTube, WhatsApp, Line et Facebook sont compatibles. Grâce à notre plate - forme, que ce soit directement, nous pouvons fournir des solutions linguistiques de haute qualité pour la promotion de produits, l'éducation en ligne et la diffusion en direct, aidant les utilisateurs à élargir leur présentation de niveau, leur marché mondial et à améliorer leur compétitivité.Choisissez - nous et ouvrez les possibilités infinies»",

        一站式解决方案: ' Une solution à guichet unique ',

        助力品牌出海: ' Aider les marques à se mondialiser',

        互动数据打造直播能手跨境利器: ' « interactive + Data » pour créer « Live talent, Cross - Border Tool »',

        开发经验: ' Expérience de développement',

        覆盖行业: ' Couverture de l’industrie »',

        客户选择: ' Choix du client ',

        行业解决方案: " Solutions pour l'industrie ",

        请输入您的电话号码: ' Veuillez entrer votre numéro de téléphone »',

        预约回电: ' Prendre rendez - vous pour un rappel, »',

        我们为您提供专业的售前及售后服务助您轻松开启跨界之旅: ' Nous vous fournissons un service professionnel avant et après - vente pour vous aider à ouvrir facilement votre voyage transfrontalier ',

        杭州国播优选科技有限公司: ' Hangzhou guobo preferred Technology Co., Ltd',

        地址: ' 6ème étage (étage entier) du bâtiment 5, route 6 Wang Sheng, district de Linping, Hangzhou, Province du Zhejiang ',

        国播优选官方微信号: ' Guobo préfère le numéro public Wechat',

        为品牌海外业绩增长提供全方位资源和服务: " Fournir des ressources et des services complets pour la croissance de la performance de la marque à l'étranger ",

        用户案例: ' Les user Stories',

        解决方案: ' La solution ',

        娱乐平台: ' Plateforme de divertissement ',

        家用电器: ' Appareils ménagers',

        游戏直播: ' Le jeu en direct ',

        教育培训: ' L’éducation et la formation',

        服饰用品: ' Vêtements et accessoires',

        知识付费: ' La connaissance paie',

        水晶珠宝: ' Bijoux en cristal ',

        宏冠赛鸽: ' Pigeon de course du Pavillon Rouge',

        致力为您提供专业的服务与支持: ' Dédié à vous fournir un service et un soutien professionnels »',

        系统搭建: ' Paramètres du système »',

        AI模型: ' Le modèle ai',

        视频编程: ' Programmation vidéo ',

        语音翻译: ' Traduction vocale ',

        全方位提供支持服务: ' Fournir une gamme complète de services de soutien ',

        产品使用指导技术问题解答: " Conseils sur l'utilisation des produits et résolution des problèmes techniques ",

        客户需求为先: ' Les besoins des clients d’abord',

        从满足客户需求到创造客户价值: ' De la satisfaction des besoins des clients à la création de valeur client ',

        落地有保障: ' Assurer la mise en œuvre »',

        专业团队为您出海赋能: ' Une équipe de professionnels pour vous propulser dans le monde entier ',

        极速服务应答: ' Réponse rapide du service ',

        小时响应724小时保驾护航: ' 1 heure de réponse, 7 * 24 heures de protection et de protection ',

        加盟合作共享品牌价值与发展机遇: ' Rejoindre la coopération, partager la valeur de la marque et les opportunités de développement »',

        代理合作: ' Coopération des agents',

        平台合作: ' Coopération de la plateforme »',

        技术合作: ' Coopération technique',

        供应链合作: "Coopération dans la chaîne d'approvisionnement '",

        合作流程: ' Le processus de coopération',

        客户需求沟通: ' Communication des besoins des clients',

        方案规划: ' Planification de solutions',

        确认需求: ' Confirmation des besoins',

        专业指导: ' Orientation professionnelle »',

        跑通流程: ' Exécuter le processus »',

        项目收尾: ' Fin du projet ',

        您可以通过以下方式快速联系我们我们携手共进开拓市场无限可能: ' Rejoignez la coopération, partagez la valeur de la marque et les opportunités de développement vous pouvez nous contacter rapidement par les moyens suivants, nous explorerons ensemble les possibilités infinies sur le marché',

        热线联系: ' Contact hotline »',

        请联系我们寻求帮助: ' Contactez - nous pour obtenir de l’aide »',

        我们将尽快为您提供帮助: ' Nous vous aiderons dès que possible »',
        关于我们的内容: " Nous vous aiderons dès que possible. Léquipe fondatrice a profondément labouré le domaine des technologies de l information sur Internet et a établi des partenariats étroits avec des entreprises nationales renommées telles que Alibaba, Tencent, 360 et d'autres.Nous adhérons au professionnalisme de« l 'innovation, lepragmatisme l'intégrité et la mise en œuvre»,avec une expérience riche de l 'industrie et des compétences professionnelles. Nous respectons les opportunités et les défis de chaque coopération, nous visons la qualité et l'auto - dépassement,en nous appuyant sur les avantages des ressources en amont et en aval de l 'industrie. Nous croyons que nous sommes en mesure de fournir des solutions exceptionnelles et un service attentionné à nos utilisateurs et que cela apportera une grande valeur commerciale et sociale",
        公司简介: ' Profil de l’entreprise »',

        我们的优势: ' Nos avantages',

        技术优势: ' Avantages techniques',

        技术支持内容: " Leader international de la technologie de reconnaissance linguistique, technologie de fusion avancée, innovation indépendante, support technique d'Alibaba,support technique européen de formation de top model,avec une équipe de développement de logiciels bien établie",

        顶尖团队: ' L’équipe top',

        国际顶尖技术团队国家千人计划技术引领国内头部跨境运营团队经验丰富资源充沛杭州外贸跨境协会加持: " L'équipe technique supérieure internationale,menant le programme national de mille personnes de la science et de la technologie;Avec le soutien de l 'Association du commerce transfrontalier de la ville de Hangzhou, une équipe nationale d'opérations transfrontalières de premier plan avec une expérience et des ressources considérables",

        低成本: ' Faible coût ',

        只需为我们的服务付费我们有竞争力的定价匹配策略意味着你能借助我们的方案获得巨大的收益: ' Ne payez que pour nos services, notre stratégie concurrentielle d’appariement des prix signifie que vous pouvez faire d’énormes profits avec nos solutions »',

        全球覆盖: ' Couverture mondiale ',

        我们在全球范围内建立了高效的供应链系统确保产品或服务的可靠供应并满足不同地区的需求: " Nous avons mis en place un système de chaîne d'approvisionnement efficace dans le monde entier pour assurer un approvisionnement fiable en produits ou services et répondre aux besoins des différentes régions."
    }
}